import { Grid } from '@material-ui/core';
import { useStyles } from '@webapps/styles';

import RelationsCard from './RelationsCard';
import Nodata from 'components/NoData';
import theme from '../theme';
import { useState } from 'react';

const Relations = ({ relations, isLoading }) => {

  const { classes, css, cx, global, theme: { spacing } } = useStyles(styles);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const {
    images: { Degree }
  } = theme

  return (
    <div >
      <Grid container className={global.paper}>
        {isLoading ? (
          <>
            {[...Array(size/2)].map((_, idx) => (
              <Grid item xs={12} sm={6} md={4} xl={3} style={{ padding: '0 20px 20px 0' }} key={idx}>
                <RelationsCard item={{}} />
              </Grid>
            ))}
          </>
        ) : relations.length > 0 ? relations.map(item => (
          <Grid key={item.id} item xs={12} sm={6} md={4} xl={3} style={{ padding: '0 20px 20px 0' }}  >
            <RelationsCard item={item} />
          </Grid>
        )) : (
          <Grid item xs={12} className={classes.noDataContainer}>
            <Nodata
              image={Degree}
              contentWidth='70%'
              padding='0px 20px 20px 0px'
              width="150px"
              title="Aucune relation trouvée"
              description="Vous n'avez pas encore de relations avec des CFAs."
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background: 'white',
    height: '100%',
    borderRadius: '0 0 10px 10px',
  },
  noDataContainer: {
    padding: '20px',
    width: '100%',
    height: '100%',
  }
});

export default Relations;
